import { createRouter, createWebHistory } from 'vue-router'
    
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/HomePage.vue'),
  },
  {
    path: '/home',
    name: 'homeAlt',
    component: () => import('@/pages/HomePage.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/pages/AboutPage.vue'), // lazy-loaded
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: () => import('@/pages/PortfolioPage.vue'), // lazy-loaded
  },
  {
    path: '/silent-respite-portfolio',
    name: 'silentRespitePortfolio',
    component: () => import('@/pages/SilentRespitePortfolio.vue'), // lazy-loaded
  },
  {
    path: '/hi-memoirs',
    name: 'hiMemoirs',
    component: () => import('@/pages/HiMemoirs.vue'), // lazy-loaded
  },
  {
    path: '/memories-of-spitafields',
    name: 'memoriesOfSpitafields',
    component: () => import('@/pages/MemoriesOfSpitafields.vue'), // lazy-loaded
  },
  {
    path: '/silent-respite',
    name: 'silentRespite',
    component: () => import('@/pages/SilentRespite.vue'), // lazy-loaded
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/pages/ContactPage.vue'), // lazy-loaded
  },
  {
    path: '/placement',
    name: 'placementOverview',
    component: () => import('@/pages/PlacementOverview.vue'), // lazy-loaded
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})